import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PasswordRefreshCardInfoAsync } from "redux/actions/password/Password.action";
import { IPassRefCardInfoState } from "models/Slices/passwordSlice.model";
import { IPasswordCardInfo } from "models/Password/password.model";

const initialState: IPassRefCardInfoState = {
  cardInfo: null,
  loading: false,
  error: "",
  errorAlert: "",
  success: false,
  cardTemp: {
    PinDigitEnc: "",
    TokenSessionId: "",
  },
};

export const PassRefCardInfoSlice = createSlice({
  name: "passRefCardInfo",
  initialState,
  reducers: {
    resetPassRefCardInfo: () => initialState,
    tempCard: (state, action: PayloadAction<object>) => {
      state.cardTemp = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PasswordRefreshCardInfoAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        PasswordRefreshCardInfoAsync.fulfilled,
        (state, action: PayloadAction<IPasswordCardInfo>) => {
          state.loading = false;
          state.cardInfo = action.payload;
          state.success =
            state.cardInfo?.DialogBoxes.length === 0 ? true : false;
        }
      )
      .addCase(PasswordRefreshCardInfoAsync.rejected, (state, action: any) => {
        state.loading = false;
        if (
          action.error?.message === "COR-94493" ||
          action.error?.message === "COR-94466" ||
          action.error?.message === "COR-50894"
        ) {
          state.errorAlert = action.error?.message;
        } else {
          state.error = action.error?.message;
        }
        state.cardInfo = null;
        state.success = false;
      });
  },
});

export const { resetPassRefCardInfo, tempCard } = PassRefCardInfoSlice.actions;

export default PassRefCardInfoSlice.reducer;
